import React from 'react';
import StyledTextField from 'components/atoms/TextField';

const ZipTextInput = (props: any): JSX.Element => {
  return (
    <React.Fragment>
      <StyledTextField {...props} InputProps={{ inputMode: 'numeric' }} />
    </React.Fragment>
  );
};

export default ZipTextInput;
